export default __webpack_public_path__ + "static/media/NIAS0570.34I-40565_-23983_0.908818a0.jpg";